export default __webpack_public_path__ + "static/media/rivitRing.643fc1ba.png";